import commonActions from '../../actions/common.actions'
import { QuickTradeProto, QuickTradesProto } from '../../proto/generated/quick-trade'
import { addOrUpdateQuickTrade, removeQuickTrade, setQuickTrades } from '../../reducer/quickTrades.reducer'
import store from '../../store'
import api from './axiosClient'

function quickTradeRequestJson(body: QuickTradeProto): string {
    return JSON.stringify(QuickTradeProto.toJSON(body))
}

export const fetchQuickTrades = (): Promise<QuickTradesProto> => {
    return new Promise((resolve, reject) => {
        const url = `/quickTrade`
        api.request({
            url: url,
            headers: {
                Accept: 'application/x-protobuf'
            },
            method: 'GET',
            responseType: 'arraybuffer',
            data: {}
        })
            .then(async (response) => {
                const result = QuickTradesProto.decode(new Uint8Array(response.data))
                store.dispatch(setQuickTrades(result.quickTrades))
                resolve(result)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const createQuickTrade = ({ body }: { body: QuickTradeProto }): Promise<QuickTradeProto> => {
    return new Promise((resolve, reject) => {
        const url = `/quickTrade`
        api.post(url, quickTradeRequestJson(body), {
            headers: {
                Accept: 'application/x-protobuf'
            },
            responseType: 'arraybuffer'
        })
            .then(async (response) => {
                const result = QuickTradeProto.decode(new Uint8Array(response.data))
                if(response.status===200) {
                    store.dispatch(addOrUpdateQuickTrade(result))
                }
                resolve(result)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const modifyQuickTrade = (request: QuickTradeProto): Promise<QuickTradeProto> => {
    return new Promise((resolve, reject) => {
        const url = `/quickTrade/modify`
        api.post(url, quickTradeRequestJson(request), {
            headers: {
                Accept: 'application/x-protobuf'
            },
            responseType: 'arraybuffer'
        })
            .then(async (response) => {
                const result = QuickTradeProto.decode(new Uint8Array(response.data))
                if(response.status===200) {
                    store.dispatch(addOrUpdateQuickTrade(result))
                    commonActions.setApiError(store.dispatch, { error: true, message: 'Quick Trade updated successfully', errorType: 'success'})
                }
                resolve(result)
               })
            .catch((error) => {
                reject(error)
            })
    })
}

export const deleteQuickTrade = (request: QuickTradeProto): Promise<void> => {
    return new Promise((resolve, reject) => {
        const url = '/quickTrade'
        api.request({
            url: url,
            headers: {
                Accept: 'application/x-protobuf'
            },
            method: 'DELETE',
            responseType: 'arraybuffer',
            data: quickTradeRequestJson(request)
        })
            .then(async (response) => {
                if(response.status===200) {
                    store.dispatch(removeQuickTrade(request?.id??''))
                }
                resolve()
            })
            .catch((error) => {
                reject(error)
            })
    })
}